
import type { RootStateType } from '../store';
import type { Auth } from './type';
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

const initialState: Auth = {
    token: "",
    user: {},
};

const authSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {
        reset: (state) => (state = initialState),
        setAuthUser: (state, action: PayloadAction<any>) => {
            state.user = action.payload.user;
            if (action.payload.token) {
                state.token = action.payload.token;
            }
        },
    },
});

export const {
    setAuthUser,
} = authSlice.actions;
export const resetAuth = authSlice.actions.reset;

export const authSliceReducer = authSlice.reducer;

export const selectUser = (state: RootStateType) => state.auth.user;

export const selectPermissions = (state: RootStateType) =>
    state.auth.user.permissions;